import { Plugin, PluginKey } from 'hubspot-prosemirror/pm/state';
import { setTrSelectionPosition } from '../utils/documentUtils';
// Per-editor state, keyed so each editor reads its OWN focus intent. Previously
// this lived in a module-level global shared by every editor on the page, so
// one editor arming its autofocus could move a DIFFERENT editor's caret to the
// document end (ProductSupport#158321).
const focusPluginKey = new PluginKey('FocusPlugin');
export const FocusPlugin = new Plugin({
  key: focusPluginKey,
  state: {
    init() {
      return {};
    },
    apply(tr, currentPluginState) {
      const meta = tr.getMeta(FocusPlugin);
      if (meta) {
        return meta;
      }
      return currentPluginState;
    }
  },
  view() {
    return {
      update: view => {
        const pluginState = focusPluginKey.getState(view.state);
        if (pluginState && pluginState.focusView) {
          // only focus if it isn't currently focused
          window.requestAnimationFrame(() => {
            if (!view.dom.isConnected) {
              return;
            }
            const state = focusPluginKey.getState(view.state);
            if (!state || !state.focusView) {
              return;
            }
            focusEditorView(view, {
              focusViewPos: state.focusViewPos,
              preserveSelection: state.preserveSelection
            });
          });
        }
      }
    };
  }
});

// Focus a live view now, reading its current state rather than a captured one.
// Shared by the plugin's view.update and by the imperative mount-autofocus in
// Prosemirror.tsx so the external-input and connection guards live in one place.
export function focusEditorView(view, {
  focusViewPos,
  preserveSelection
} = {}) {
  // The editor can unmount before this runs; acting on a destroyed view throws.
  if (!view.dom.isConnected) {
    return;
  }
  const active = document.activeElement;
  if (active instanceof HTMLElement && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA') && !view.dom.contains(active)) {
    // Focus is in an external input; do not steal it. Clear any intent so
    // subsequent re-renders do not keep scheduling frames.
    view.dispatch(view.state.tr.setMeta(FocusPlugin, {}));
    return;
  }
  if (!preserveSelection && view.hasFocus()) {
    return;
  }
  if (!view.hasFocus()) {
    view.focus();
  }
  const tr = preserveSelection ? view.state.tr : setTrSelectionPosition(view.state.tr, focusViewPos);
  view.dispatch(tr.setMeta(FocusPlugin, {}));
}